import { Checkbox, Link } from "@fluentui/react-components";
import { useFormikContext } from "formik";
import { useAtomValue } from "jotai";
import { useTranslation } from "react-i18next";
import { selectedClientAtom } from "store";
import styled from "styled-components";

import { ErrorMessageContainer, Flex, Grid, StyledErrorMessage } from "components/styled";

export function GrecoSensitiveConsentTextSection() {
  const { t } = useTranslation();
  const selectedClient = useAtomValue(selectedClientAtom);

  const { values, errors, setFieldValue } = useFormikContext<FormData>();
  return (
    <Container>
      <Grid gridColumns={1}>
        <Flex align="center">
          <Checkbox
            name={"isGrECoSensitiveDataConsentGiven"}
            checked={values["isGrECoSensitiveDataConsentGiven"]}
            onChange={(ev, data) => {
              const checked = !!data.checked;
              setFieldValue("isGrECoSensitiveDataConsentGiven", checked);
              setFieldValue(
                "consentText",
                checked ? selectedClient?.sensitiveDataConsentDocumentUrl : ""
              );
            }}
          />

          <Flex align="baseline">
            <Link
              target="_blank"
              href={selectedClient?.sensitiveDataConsentDocumentUrl}
              style={{
                textDecoration: "underline",
              }}
            >
              {t("hbh.iAgreeToSensitiveConsent.label")}
            </Link>
          </Flex>
        </Flex>
        <ErrorMessageContainer>
          <StyledErrorMessage>{errors["isGrECoSensitiveDataConsentGiven"]}</StyledErrorMessage>
        </ErrorMessageContainer>
      </Grid>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 20px;
`;
